import styled from '@emotion/styled'

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // workaround as Veneer IconWarning is not answering the size
  svg {
    max-width: 40px;
    margin-right: 15px;
  }
`

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LoaderWrapper = styled.div`
  margin-top: 20px;
`
